import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import employment_history_svg from "../../assets/images/Profile_pic1.png";
// import profilePic from "../../assets/images/profilePic.png";
import profilePic from "../../assets/images/default-img.jpg";
import ProfileDetailDrawer from "../Profile/profileDetailDrawer";
import UserProfile from "../casp/common/userProfile";
import { withTranslation } from "react-i18next";

const ProfileDropdown = (props) => {
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };


  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  function stringAvatar(name) {
    if (!name) {
      return {}
    }
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }
  const [isProfileDetailToggle, setProfileDetailToggle] = useState(false);
  const toggleProfileDetail = () => {
    setProfileDetailToggle(!isProfileDetailToggle);
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-2 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            {/* <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" /> */}
            {/* <img
              style={{ objectFit: "cover" }}
              src={profilePic}
              className="rounded-circle header-profile-user"
            /> */}
            <UserProfile user={user} />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
               {user?.name}
              </span>
              {/* <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {role}
              </span> */}
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">Welcome {user?.name}!</h6>
          <DropdownItem onClick={toggleProfileDetail}> 
            <div className="d-flex align-items-center">
            <UserProfile user={user} profileStyle ={{height: '30px', width: '30px', fontSize: '15px'}}/>
              <span className="align-middle mx-2">{props.t('Profile')}</span>
            </div>
          </DropdownItem>
          {/* <DropdownItem href="/apps-chat">
            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Messages</span>
          </DropdownItem> */}
          {/* <DropdownItem href="#">
            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Taskboard</span>
          </DropdownItem> */}
          {/* <DropdownItem href="/pages-faqs"><i
                        className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Help</span></DropdownItem> */}
          <div className="dropdown-divider"></div>
          {/* <DropdownItem href="/pages-profile"><i
                        className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Balance : <b>$5971.67</b></span></DropdownItem> */}
          {/* <DropdownItem href="/pages-profile-settings">
            <span className="badge bg-soft-success text-success mt-1 float-end">
              New
            </span>
            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Settings</span>
          </DropdownItem> */}
          {/* <DropdownItem href="/auth-lockscreen-basic"><i
                        className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span></DropdownItem> */}
          <DropdownItem href="/logout">
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              {props.t('Logout')}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      {isProfileDetailToggle &&
        <ProfileDetailDrawer isOpenProfileDetail = {isProfileDetailToggle} toggle={toggleProfileDetail}/>
      }
    </React.Fragment>
    
  );
};

export default  withTranslation() (ProfileDropdown);
